import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Overflow = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => {
  const pathColor = getColor(color, isColorInherited);

  return (
    <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
      <path
        d="M9.19995 3.2C9.19995 2.96266 9.12957 2.73066 8.99772 2.53332C8.86586 2.33598 8.67844 2.18217 8.45917 2.09135C8.2399 2.00052 7.99862 1.97676 7.76584 2.02306C7.53307 2.06936 7.31925 2.18365 7.15142 2.35147C6.9836 2.5193 6.86931 2.73311 6.82301 2.96589C6.77671 3.19867 6.80047 3.43995 6.8913 3.65922C6.98212 3.87849 7.13593 4.06591 7.33327 4.19776C7.53061 4.32962 7.76261 4.4 7.99995 4.4C8.31821 4.4 8.62344 4.27357 8.84848 4.04853C9.07352 3.82348 9.19995 3.51826 9.19995 3.2Z"
        fill={pathColor}
        stroke={pathColor}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.19995 12.8C9.19995 12.5627 9.12957 12.3307 8.99772 12.1333C8.86586 11.936 8.67844 11.7822 8.45917 11.6914C8.2399 11.6005 7.99862 11.5768 7.76584 11.6231C7.53307 11.6694 7.31925 11.7837 7.15142 11.9515C6.9836 12.1193 6.86931 12.3331 6.82301 12.5659C6.77671 12.7987 6.80047 13.04 6.8913 13.2592C6.98212 13.4785 7.13593 13.6659 7.33327 13.7978C7.53061 13.9296 7.76261 14 7.99995 14C8.31821 14 8.62344 13.8736 8.84848 13.6485C9.07352 13.4235 9.19995 13.1183 9.19995 12.8Z"
        fill={pathColor}
        stroke={pathColor}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.19995 7.99999C9.19995 7.76265 9.12957 7.53064 8.99772 7.3333C8.86586 7.13597 8.67844 6.98216 8.45917 6.89133C8.2399 6.80051 7.99862 6.77674 7.76584 6.82305C7.53307 6.86935 7.31925 6.98364 7.15142 7.15146C6.9836 7.31928 6.86931 7.5331 6.82301 7.76588C6.77671 7.99866 6.80047 8.23994 6.8913 8.45921C6.98212 8.67848 7.13593 8.86589 7.33327 8.99775C7.53061 9.12961 7.76261 9.19999 7.99995 9.19999C8.31821 9.19999 8.62344 9.07356 8.84848 8.84852C9.07352 8.62347 9.19995 8.31825 9.19995 7.99999Z"
        fill={pathColor}
        stroke={pathColor}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  );
};
